﻿module.exports = {
    bindings: {
        isLarge: '<',
        item: '<'
    },
    controller: chapterNotesButton,
    templateUrl: 'texts/components/chapter-notes-button.html'
};

chapterNotesButton.$inject = ['annotationsModal'];

function chapterNotesButton(annotationsModal) {

    var vm = {
        showAnnotation: showAnnotation
    };

    function showAnnotation() {
        annotationsModal.show(null, vm.item.chapter, null);
    }


    return vm;

}